'use strict';

class BonnetModule {
  constructor(options) {
    this.options = options;

    // assign the module duck
    this.duck = options.duck;

    // assign the module middleware
    this.ctxMiddleware = this.options.ctxMiddleware.bind(null, {
      duck: this.duck
    });
  }
  extend({
    duck: duckExtension = {},
    ctxMiddleware: ctxMiddlewareExtension
  }) {
    this.duck = this.duck.extend(duckExtension);

    // updated original middleware with new extended duck instance
    const updatedOriginalCtxMiddleware = this.options.ctxMiddleware.bind(null, {
      duck: this.duck
    });
    if (typeof ctxMiddlewareExtension === 'function') {
      this.ctxMiddleware = ctxMiddlewareExtension.bind(null, {
        duck: this.duck,
        // create an instance of the original ctx-middleware and pass to extension
        ctxMiddleware: updatedOriginalCtxMiddleware()
      });
    } else {
      this.ctxMiddleware = updatedOriginalCtxMiddleware;
    }

    // return a new module instance
    return new BonnetModule({
      duck: this.duck,
      ctxMiddleware: this.ctxMiddleware
    });
  }
}

exports.BonnetModule = BonnetModule;
